export const routes = [
  {
    path: '/',
    name: 'login',
    meta: {
      title: 'Se connecter',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/premiere-connexion/:token',
    name: 'activateAccount',
    meta: {
      title: 'Activation du compte',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/Login.vue'),
    props: true
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      title: 'Déconnexion'
    },
    notInSitemap: true,
    component: () => import('../views/Logout.vue')
  },
  {
    path: '/accueil',
    name: 'home',
    meta: {
      title: 'Tableau de bord'
    },
    component: () => import('../views/Home.vue')
  },
  {
    path: '/plan-du-site',
    name: 'siteMap',
    meta: {
      title: 'Plan du site'
    },
    component: () => import('../views/PlanDuSite.vue')
  },
  {
    path: '/mes-information-aux-parents',
    name: 'infosParents',
    meta: {
      title: 'Mes informations aux parents'
    },
    component: () => import('../views/InfosParents.vue')
  },
  {
    path: '/actualites-et-reglementations',
    name: 'actus',
    meta: {
      title: 'Actualités et Réglementations'
    },
    component: () => import('../views/Actus.vue')
  },
  {
    path: '/aide',
    name: 'aide',
    meta: {
      title: 'Aide',
    },
    notInSitemap: true,
    component: () => import('../views/Aide.vue')
  },
  {
    path: '/mes-disponibilites',
    name: 'dispos',
    meta: {
      title: 'Mes disponibilités'
    },
    component: () => import('../views/Dispos.vue'),
    props: true
  },
  {
    path: '/mes-disponibilites/nouvelle',
    name: 'dispofuture',
    meta: {
      title: 'Ajouter une disponibilité future'
    },
    component: () => import('../views/DispoFuture.vue')
  },
  {
    path: '/mes-disponibilites/:dispoId',
    name: 'dispofutureUpdate',
    meta: {
      title: 'Modifier la disponibilité future'
    },
    notInSitemap: true,
    component: () => import('../views/DispoFuture.vue'),
    props: true
  },
  {
    path: '/mes-accueils',
    name: 'mesAccueils',
    meta: {
      title: 'Mes accueils'
    },
    component: () => import('../views/Accueils.vue'),
    props: true
  },
  {
    path: '/mes-accueils/choix-declaration',
    name: 'choixAccueil',
    meta: {
      title: 'Choix du type d’accueil'
    },
    component: () => import('../views/ChoixAccueil.vue'),
    props: true
  },
  {
    path: '/mes-accueils/declaration',
    name: 'accueilDeclaration',
    meta: {
      title: 'Nouvel accueil'
    },
    component: () => import('../views/AccueilEnfant.vue'),
    props: true
  },
  {
    path: '/mes-accueils/supplementaire',
    name: 'accueilSupplementaire',
    meta: {
      title: 'Accueil supplémentaire'
    },
    component: () => import('../views/AccueilSupplementaire.vue'),
    props: true
  },
  {
    path: '/mes-accueils/surnombre',
    name: 'accueilSurnombre',
    meta: {
      title: 'Accueil en surnombre'
    },
    component: () => import('../views/AccueilSurnombre.vue'),
    props: true
  },
  {
    path: '/mes-accueils/:idEnfant',
    name: 'ficheEnfant',
    meta: {
      title: 'Fiche accueil'
    },
    notInSitemap: true,
    component: () => import('../views/FicheEnfant.vue'),
    props: true
  },
  {
    path: '/mes-accueils/:idEnfant/modification',
    name: 'ficheEnfantModify',
    meta: {
      title: 'Modification de l’accueil'
    },
    notInSitemap: true,
    component: () => import('../views/AccueilEnfant.vue'),
    props: true
  },
  {
    path: '/mes-accueils/:idEnfant/cloture',
    name: 'ficheEnfantDelete',
    meta: {
      title: 'Clôture de l’accueil'
    },
    notInSitemap: true,
    component: () => import('../views/ClotureAccueilEnfant.vue'),
    props: true
  },
  {
    path: '/mes-accueils/derogatoire/:idAccueil',
    name: 'ficheAccueilDerogatoire',
    meta: {
      title: 'Clôture de l’accueil dérogatoire'
    },
    notInSitemap: true,
    component: () => import('../views/ClotureAccueilDerogatoire.vue'),
    props: true
  },
  {
    path: '/mon-compte',
    name: 'monCompte',
    meta: {
      title: 'Mon compte',
      requiresAuth: true
    },
    component: () => import('../views/MonCompte.vue')
  },
  {
    path: '/mot-de-passe-oublie',
    name: 'forgotPassword',
    meta: {
      title: 'Mot de passe oublié ?',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/ForgotPassword.vue')
  },
  {
    path: '/mot-de-passe-oublie/:token',
    name: 'resetPassword',
    meta: {
      title: 'Réinitialisation du mot de passe',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/ResetPassword.vue'),
    props: true
  },
  {
    path: '/premiere-connexion/',
    name: 'firstConnection',
    meta: {
      title: 'Première connexion',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/FirstConnection.vue'),
    props: true
  },
  {
    path: '/accessibilite',
    name: 'accessibilite',
    meta: {
      title: 'Accessibilité'
    },
    component: () => import('../views/Accessibilite.vue')
  },
  {
    path: '*',
    name: '404',
    meta: {
      title: 'Page non trouvée',
      layout: 'TwoColumns',
      isPublic: true
    },
    component: () => import('../views/PageNotFound.vue')
  },
]